<template>
  <div class="d-flex flex-column credits-container container__credit-spend">
    <v-row no-gutters>
      <v-col class="d-flex">
        <span
          class="text-caption mr-2 line-height--fixed"
          :class="{
            'text--textType neutral--text text--lighten-1':
              !$vuetify.theme.dark,
          }"
          >{{ $i18next.t('message.ai.spendCard.amount') }}</span
        >
        <span
          class="font-weight-bold brand--text text-caption line-height--fixed pointer"
          @click="handleGoChargeCredits"
          >{{ $i18next.t('message.ai.spendCard.addCredits') }}</span
        >
      </v-col>
      <v-col class="d-flex justify-end align-center">
        <v-card width="16" height="16" flat class="mr-1">
          <v-img
            src="@/assets/credit_blue_darken_icon.svg"
            class="credit-icon"
          />
        </v-card>
        <span
          class="font-weight-medium text-caption line-height--fixed"
          :class="{ 'brand--text text--darken-1': !$vuetify.theme.dark }"
          >{{ getCreditValue(amount) }}</span
        >
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col>
        <span
          class="text-caption line-height--fixed"
          :class="{
            'text--textType neutral--text text--lighten-1':
              !$vuetify.theme.dark,
          }"
          >{{ $i18next.t('message.ai.spendCard.charge') }}</span
        >
      </v-col>
      <v-col class="d-flex justify-end align-center">
        <div
          v-if="calcPriceNoPromo"
          class="price-no-promo"
          :class="{ 'line-through-color': !$vuetify.theme.dark }"
        >
          <v-card
            flat
            class="mr-1 ml-2"
            :class="
              $vuetify.theme.dark
                ? 'adjust-icon-size-darkmode'
                : 'adjust-icon-size'
            "
          >
            <v-img
              src="@/assets/credit_red_danger_icon.svg"
              class="credit-icon"
            />
          </v-card>
          <span
            class="line-height--fixed mr-2 font-size"
            :class="{ 'feedback-text': !$vuetify.theme.dark }"
            >- {{ getCreditValue(calcPriceNoPromo) }}
          </span>
        </div>
        <v-card
          flat
          class="mr-1"
          :class="
            $vuetify.theme.dark
              ? 'adjust-icon-size-darkmode'
              : 'adjust-icon-size'
          "
        >
          <v-img
            src="@/assets/credit_red_danger_icon.svg"
            class="credit-icon"
          />
        </v-card>
        <span
          class="font-size line-height--fixed"
          :class="{ 'feedback-text': !$vuetify.theme.dark }"
          >- {{ getCreditValue(spendPrice) }}
        </span>
      </v-col>
    </v-row>
    <hr class="divider__values" />
    <v-row no-gutters>
      <v-col>
        <span
          class="text-caption line-height--fixed"
          :class="{
            'text--textType neutral--text text--lighten-1':
              !$vuetify.theme.dark,
          }"
        >
          {{ $i18next.t('message.ai.spendCard.remainingAmount') }}
        </span>
      </v-col>
      <v-col class="d-flex justify-end align-center">
        <v-card width="16" height="16" flat class="mr-1">
          <v-img src="@/assets/credit_small_icon.svg" class="credit-icon" />
        </v-card>
        <span
          class="text-caption line-height--fixed"
          :class="{ 'neutral--text': !$vuetify.theme.dark }"
          >{{ getCreditValue(subCalc) }}</span
        >
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'CreditSpendCard',
  props: {
    amount: {
      type: Number,
      required: true,
    },
    spendPrice: {
      type: Number,
      required: true,
    },
    subCalc: {
      type: Number,
      required: true,
    },
    parentModalKey: {
      type: String,
      required: true,
    },
  },
  methods: {
    getCreditValue(val) {
      return val.toLocaleString(this.currencyLocale, {
        maximumFractionDigits: 0,
      })
    },
    handleGoChargeCredits() {
      this.$root.$emit(`close${this.parentModalKey}`)
      this.$router.push({ name: 'Credits', query: { charge: 'true' } })
    },
  },
  computed: {
    currencyLocale() {
      const currency = this.$store.state.user.userPlanInfo.currency
      let locale = 'pt-BR'
      if (currency === 'usd') {
        locale = 'en-US'
      }
      return locale
    },
    calcPriceNoPromo() {
      const isDub = this.parentModalKey === 'DubbingModal' ? true : false
      const promoFactor = isDub ? 5 : 3
      let priceNoPromo = this.spendPrice * promoFactor
      return priceNoPromo
    },
  },
}
</script>

<style lang="scss">
.credit-icon {
  .v-image__image {
    background-color: var(--v-contrast-base);
  }
}

.line-height--fixed {
  line-height: 150%;
  display: block;
}

.divider {
  &__values {
    border-color: var(--v-neutral-lighten2);
    border-style: solid;
    margin: 6px 0;
  }
}
.feedback-text {
  color: #b71c1c;
}
.adjust-icon-size-darkmode {
  width: 14px !important;
  height: 14px !important;
}
.adjust-icon-size {
  width: 16px !important;
  height: 16px !important;
}
.price-no-promo {
  position: relative;
  display: flex;
  align-items: center;
  margin-right: 16px !important;
}
.price-no-promo::after {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  width: 100%;
  height: 1px;
  background: rgb(255, 0, 0);
  opacity: 0.7;
}

.price-no-promo.line-through-color::after {
  background: rgb(0, 0, 0);
}
.font-size {
  font-size: small !important;
}
.credit-spend-col {
  flex-direction: column;
}
</style>
